import React, { useState, forwardRef } from "react";
import { Link } from "react-router-dom";
import Resilienceimagesvg from "../static/img/Resilience Web page (2).jpg";
import "../static/css/Event1reg.css";

const Event1reg = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    profession: "",
    role: "attendee",
    about_us: "",
    email: "",
    phone: "",
    agreeToTerms: false,
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let newErrors = {};
    const { name, organization, email, phone, profession, agreeToTerms } = formData;

    if (!name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!organization.trim()) {
      newErrors.organization = "Organization is required.";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid.";
    }

    if (!phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d+$/.test(phone)) {
      newErrors.phone = "Phone number should contain only digits.";
    }

    if (!profession.trim()) {
      newErrors.profession = "Profession/job title is required.";
    }

    if (!agreeToTerms) {
      newErrors.agreeToTerms = "You must agree to the terms.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submission triggered");

    if (validate()) {
      console.log("Validation passed, submitting form");

      fetch("https://eventbe.quindl.com/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then((data) => {
          console.log("Data from register API:", data);

          fetch("https://eventbe.quindl.com/api/link", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: formData.email }),
          })
            .then((response) => response.json())
            .then((linkResponse) => {
              console.log("Data from link API:", linkResponse);
            })
            .catch((error) => {
              console.error("Error calling Link API:", error);
            });

          setIsSubmitted(true);

          setFormData({
            name: "",
            organization: "",
            profession: "",
            role: "attendee",
            about_us: "",
            email: "",
            phone: "",
            agreeToTerms: false,
          });

          setTimeout(() => {
            setIsSubmitted(false);
          }, 3000);
        })
        .catch((error) => {
          console.error("Error during registration:", error);
        });
    }
  };

  return (
    <>
      <div ref={ref} className="event1reg">
        <div className="event1reg-container">
          <div className="event1reg-title">
            <p>The Resilience Summit</p>
          </div>

          <div className="registration-form-container">
            <form className="registration-form" onSubmit={handleSubmit}>
              <p>Registration form</p>

              <div className="form-columns">
                <div className="form-left">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    {errors.name && <span className="error">{errors.name}</span>}
                  </div>

                  <div className="form-group">
                    <label>Organization</label>
                    <input
                      type="text"
                      name="organization"
                      value={formData.organization}
                      onChange={handleChange}
                      required
                    />
                    {errors.organization && (
                      <span className="error">{errors.organization}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>E-mail</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    {errors.email && <span className="error">{errors.email}</span>}
                  </div>

                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                    {errors.phone && <span className="error">{errors.phone}</span>}
                  </div>
                </div>

                <div className="form-right">
                  <div className="form-group">
                    <label>Role</label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      required
                    >
                      <option value="attendee">Attendee</option>
                      <option value="panelist">Panelist</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Profession/Job title</label>
                    <input
                      type="text"
                      name="profession"
                      value={formData.profession}
                      onChange={handleChange}
                      required
                    />
                    {errors.profession && (
                      <span className="error">{errors.profession}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>How Did You Hear About Us?</label>
                    <select
                      name="about_us"
                      value={formData.about_us}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      <option value="social media">Social media</option>
                      <option value="business groups">Business groups</option>
                      <option value="internet advertisements">
                        Internet Advertisements
                      </option>
                      <option value="search engine">Search engine</option>
                      <option value="employee referral">Employee referral</option>
                      <option value="Friends/families">Friends / families</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  name="agreeToTerms"
                  checked={formData.agreeToTerms}
                  onChange={handleChange}
                  required
                />
                <label>
                  I agree to the <Link to="/terms-and-conditions">Terms & conditions</Link>
                </label>
                {errors.agreeToTerms && (
                  <span className="error">{errors.agreeToTerms}</span>
                )}
              </div>

              <div className="submit-button">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
        <div className="event1-svg">
          <img src={Resilienceimagesvg} alt="Event SVG" />
        </div>
        {isSubmitted && (
          <div className="popup-message">
            <p>Thank you for registering</p>
            <p>Kindly check your E-mail for confirmation</p>
          </div>
        )}
      </div>
    </>
  );
});

export default Event1reg;
